/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Period_Preset_30dInputs */

const cs_dashboard_period_preset_30d = /** @type {(inputs: Dashboard_Period_Preset_30dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 dní`)
};

const en_dashboard_period_preset_30d = /** @type {(inputs: Dashboard_Period_Preset_30dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 days`)
};

/**
* | output |
* | --- |
* | "30 days" |
*
* @param {Dashboard_Period_Preset_30dInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_period_preset_30d = /** @type {((inputs?: Dashboard_Period_Preset_30dInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Period_Preset_30dInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_period_preset_30d(inputs)
	return cs_dashboard_period_preset_30d(inputs)
});